/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementListItemResponse } from './StoreManagementListItemResponse';

export type StoreManagementListItemResponseApiRespoonse = {
    data?: StoreManagementListItemResponse;
    status?: StoreManagementListItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementListItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

